import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { BeneficiosTributariosDescuentosModalComponent } from '../../beneficios-tributarios/beneficios-tributarios-descuentos/beneficios-tributarios-descuentos-modal.component';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';
import { ifError } from 'assert';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';

const stepsList = [
  /*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['381'] }
];

const tableStructure = [
  { id: 'pagador', title: 'Nombre pagador' },
  { id: 'origen', title: 'Origen de la información' },
  { id: 'nombreConcepto', title: 'Concepto' },
  { id: 'valorItem', title: 'Valor' }
];


class Form1 {

  id: number;
  idSugerida: number;

  pagador: string;    //490
  origen: string;    //491
  concepto: string;    //492
  nombreConcepto: string;
  valorItem: string;    //493
  valorTotal: string;    //494
  tarifa: string;    //499
  retencion: string;    //500
  impuestoPagadoExterior: string;    //501
  informante: string;
  // 381	Tuvo ingresos por dividendos y participaciones?
  // 490	Pagador
  // 491	OrigenDeLaInformación
  // 492	Concepto
  // 493	valorItem
  // 494	valorTotal
  // 499	tarifas
  // 500	retención
  // 501	impuestoPagadoExterior
  controlSugeridaForm: ControlSugeridaForm;
}
class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ingresos-dividendos-participaciones-modal.component-modal',
  templateUrl: './ingresos-dividendos-participaciones-modal.component.html',
  styleUrls: ['./ingresos-dividendos-participaciones-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosDividendosOParticipacionesModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstSiNo: ArticulosDominio[] = [];
  public lstConceptos: ArticulosDominio[] = [];
  public lstTarifas: ArticulosDominio[] = [];
  public lstCostoFiscal: ArticulosDominio[] = [];
  public lstArticulos: ArticulosDominio[] = [];
  public lstTipoActivos: ArticulosDominio[] = [];
  public listaUbicacion: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;
  tablaArt73: any;
  listaModoAdquisicion: any;
  model: DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<IngresosDividendosOParticipacionesModalComponent>,
    private _componentFactory: ComponentFactoryService,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
    console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    // this.validateShowSave();
    //this.reloadSelArticulos();
    this.initializeAnios();
    console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {

  }


  protected inicializeForm() {

    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.idSugerida = 0;


    this.modelForm.pagador = '';
    this.modelForm.origen = '';
    this.modelForm.concepto = '';
    this.modelForm.valorItem = '0';
    this.modelForm.valorTotal = '0';
    this.modelForm.tarifa = '';
    this.modelForm.retencion = '0';
    this.modelForm.impuestoPagadoExterior = '0';

    this.reloadSelArticulos();
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_490 == undefined) {


      this.model.doc.cuerpo.cc_id_490 = []; //Pagador
      this.model.doc.cuerpo.cc_id_491 = []; //OrigenDeLaInformación
      this.model.doc.cuerpo.cc_id_492 = []; //Concepto
      this.model.doc.cuerpo.cc_id_493 = []; //valorItem
      this.model.doc.cuerpo.cs_id_494 = this.model.doc.cuerpo.cs_id_494? this.model.doc.cuerpo.cs_id_494:'0'; //valorTotal
      this.model.doc.cuerpo.cc_id_499 = []; //tarifas
      this.model.doc.cuerpo.cc_id_500 = []; //retención
      this.model.doc.cuerpo.cc_id_501 = []; //impuestoPagadoExterior




    }
  }

  protected reloadSelArticulos(conservarArt?: boolean) {//Dom 1649
    this.lstSiNo[0] = { valor: 0, nombre: "No" };
    this.lstSiNo[1] = { valor: 1, nombre: "Sí" };

    this.lstConceptos[0] = { valor: 1, nombre: "Dividendo y participa  2016 y anteriores " };
    this.lstConceptos[1] = { valor: 2, nombre: "Dividendo no gravado" };
    this.lstConceptos[2] = { valor: 3, nombre: "Dividendo gravado" };
    this.lstConceptos[3] = { valor: 4, nombre: "Dividendo del exterior (no incluye dividendos CAN)" };

    //    //    Lista de tarifas
    this.lstTarifas[0] = { valor: 0, nombre: "0%" };//0%
    this.lstTarifas[1] = { valor: 5, nombre: "5%" };//5%
    this.lstTarifas[2] = { valor: 8.75, nombre: "8.75%" };//8.75%
    this.lstTarifas[3] = { valor: 9, nombre: "9%" };//9%
    this.lstTarifas[4] = { valor: 15, nombre: "15%" };//15%
    this.lstTarifas[5] = { valor: 17.5, nombre: "17.50%" };//17.50%
    this.lstTarifas[6] = { valor: 20, nombre: "20%" };//20%
    this.lstTarifas[7] = { valor: 26.25, nombre: "26.25%" };//26.25%
    this.lstTarifas[8] = { valor: 27, nombre: "27%" };//27%
    this.lstTarifas[9] = { valor: 33, nombre: "33%" };//33%
    this.lstTarifas[10] = { valor: 35, nombre: "35%" };//35%
    this.lstTarifas[11] = { valor: 38, nombre: "38%" };//38%
    this.lstTarifas[12] = { valor: 40, nombre: "40%" };//40%
    this.lstTarifas[13] = { valor: 45, nombre: "45%" };//45%
    this.lstTarifas[14] = { valor: 50, nombre: "50%" };//50%
  }

  protected initializeAnios() {

    this.lstAnios = this.tablaArt73
      .filter(item => item.anioGravable === "2023")
      .map(item => item.anio);

  }

  public operacionCs494() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valorItem, suma);
    }
    if (suma)
      this.model.doc.cuerpo.cs_id_494 = suma;
    else
      this.model.doc.cuerpo.cs_id_494 = '0';
  }



  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;

    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }

  operacionCS158() {
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158, true);
  }


  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_490.length; i++) {
      this.modelForm.id = i;

      this.modelForm.pagador = this.model.doc.cuerpo.cc_id_490[i].v;
      this.modelForm.origen = this.model.doc.cuerpo.cc_id_491[i].v;
      this.modelForm.concepto = this.model.doc.cuerpo.cc_id_492[i].v;
      if (this.lstConceptos.find(item => item.valor==this.model.doc.cuerpo.cc_id_492[i].v)) {
        this.modelForm.nombreConcepto = this.lstConceptos.find(item => item.valor==this.model.doc.cuerpo.cc_id_492[i].v).nombre;
        }
      // this.modelForm.nombreConcepto = this.lstConceptos[Number(this.model.doc.cuerpo.cc_id_492[i].v) - 1].nombre;
      this.modelForm.valorItem = this.model.doc.cuerpo.cc_id_493[i].v;
      this.modelForm.tarifa = this.model.doc.cuerpo.cc_id_499[i].v;
      this.modelForm.retencion = this.model.doc.cuerpo.cc_id_500[i].v;
      this.modelForm.impuestoPagadoExterior = this.model.doc.cuerpo.cc_id_501[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeSugerida() {

    let indexModel = this.model.doc.cuerpo.cc_id_490.length;
    if (indexModel == 0) {
      const fieldsRecovery = ['VAR_4427','VAR_4428','VAR_4782','VAR_4436','VAR_4437','VAR_4787','VAR_4452','VAR_4453','VAR_4797','VAR_4444','VAR_4445','VAR_4792','VAR_4432','VAR_4440','VAR_4448','VAR_4456'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      
      const grupos=[
        ['VAR_4427','VAR_4428','VAR_4782','VAR_4436','VAR_4437','VAR_4787','VAR_4452','VAR_4453','VAR_4797','VAR_4444','VAR_4445','VAR_4792'],
        ['VAR_4432','VAR_4440','VAR_4448','VAR_4456']
      ];

      if (resData) {
        for (let i=0; i<resData.length; i++) {
          for (let j=0; j<resData[i].item.value.length; j++) {
    
              this.modelForm.id = indexModel;
              this.modelForm.origen = '0';//this.data.sugerida[i].origen;
              this.modelForm.concepto = '2';
              this.modelForm.pagador=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];
              
              if(resData[i].key=="VAR_4427" || resData[i].key=="VAR_4428" || resData[i].key=="VAR_4437" || resData[i].key=="VAR_4436" ){
                this.modelForm.concepto= "1"; 
              }
              if(resData[i].key=="VAR_4452" || resData[i].key=="VAR_4453" || resData[i].key=="VAR_4792" ){
                this.modelForm.concepto= "2"; 
              }
              if(resData[i].key=="VAR_4782" || resData[i].key=="VAR_4787" || resData[i].key=="VAR_4797" || resData[i].key=="VAR_4444" || resData[i].key=="VAR_4445" ){
                this.modelForm.concepto= "3"; 
              }

              if(this.modelForm.concepto && this.modelForm.concepto!='' && this.lstConceptos.find(item=>item.valor==Number(this.modelForm.concepto)))
                this.modelForm.nombreConcepto = this.lstConceptos.find(item=>item.valor==Number(this.modelForm.concepto)).nombre;

              let itemGrupoFormPorEditar:Form1 = null;

              //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
              let idGrupo:number = -1;
              for(let k=0;k<grupos.length;k++){
                if(grupos[k].includes(resData[i].key)){
                  idGrupo=k;
                  break;
                }
              }

              //1. El nit ya existe? NO ->1:Agregar
              if(this.dataSourceBody.find((el)=>{
                return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
              })==undefined){
                itemGrupoFormPorEditar = null;
              }else{

                //2. Trae array de solo los del NIT
                let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                  if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                    return el;
                  }
                });

                //3. Recorrer array de solo los del NIT
                for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                  //En el registro existe una variable del GRUPO? 
                  //  - NO: Debe Editar el registro y deja de buscar
                  //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
                  let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                  if(!dataGrupo){
                    itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                    break;
                  }
                }

              }
              
              //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
              if(itemGrupoFormPorEditar){
                this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                  if(itemModelForm.id == itemGrupoFormPorEditar.id){
                    itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                    itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
                  }
                  return itemModelForm;
                });
              }else{
                this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
                this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
                this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
                this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                this.redondearFormData();
                this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
                this.dataSourceBody.push(this.modelForm);
                this.inicializeForm();
                indexModel++;
              }
    
          }
        }
      }

    }

    this.operacionCs494();
  }

  
  private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
    switch(idGrupo){//Depende de la variable array grupos
      case 0:
        itemModelForm.valorItem=String(valor);
      break;
      case 1:
        itemModelForm.retencion=String(valor);
      break;
      default:
      break;
    }
    return itemModelForm;
  }


  public editModeloDesdeForm() {


    this.model.doc.cuerpo.cc_id_490[this.modelForm.id].v = this.modelForm.pagador.toString();
    this.model.doc.cuerpo.cc_id_491[this.modelForm.id].v = this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_492[this.modelForm.id].v = this.modelForm.concepto.toString();
    this.model.doc.cuerpo.cc_id_493[this.modelForm.id].v = this.modelForm.valorItem.toString();
    this.model.doc.cuerpo.cc_id_499[this.modelForm.id].v = this.modelForm.tarifa.toString();
    this.model.doc.cuerpo.cc_id_500[this.modelForm.id].v = this.modelForm.retencion.toString();
    this.model.doc.cuerpo.cc_id_501[this.modelForm.id].v = this.modelForm.impuestoPagadoExterior.toString();


  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;


    this.model.doc.cuerpo.cc_id_490.push({ it: i, v: this.modelForm.pagador });
    this.model.doc.cuerpo.cc_id_491.push({ it: i, v: this.modelForm.origen });
    this.model.doc.cuerpo.cc_id_492.push({ it: i, v: this.modelForm.concepto });
    this.model.doc.cuerpo.cc_id_493.push({ it: i, v: this.modelForm.valorItem });
    this.model.doc.cuerpo.cc_id_499.push({ it: i, v: this.modelForm.tarifa });
    this.model.doc.cuerpo.cc_id_500.push({ it: i, v: this.modelForm.retencion });
    this.model.doc.cuerpo.cc_id_501.push({ it: i, v: this.modelForm.impuestoPagadoExterior });

  }

  public deleteOnModel(index: number) {



    this.model.doc.cuerpo.cc_id_490.splice(index, 1);
    this.model.doc.cuerpo.cc_id_491.splice(index, 1);
    this.model.doc.cuerpo.cc_id_492.splice(index, 1);
    this.model.doc.cuerpo.cc_id_493.splice(index, 1);
    this.model.doc.cuerpo.cc_id_499.splice(index, 1);
    this.model.doc.cuerpo.cc_id_500.splice(index, 1);
    this.model.doc.cuerpo.cc_id_501.splice(index, 1);



    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_490.length; i++) {

      this.model.doc.cuerpo.cc_id_490[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_491[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_492[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_493[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_499[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_500[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_501[i].it = i + 1;

    }
  }

  public validateFormCompleted(): boolean {


    return (

      this.modelForm.pagador == undefined || this.modelForm.pagador == null ||
      this.modelForm.origen == undefined || this.modelForm.origen == null ||
      this.modelForm.concepto == undefined || this.modelForm.concepto == null ||
      this.modelForm.valorItem == undefined || this.modelForm.valorItem == null ||
      this.modelForm.tarifa == undefined && this.modelForm.concepto == '3' ||
      this.modelForm.tarifa == null && this.modelForm.concepto == '3' ||
      this.modelForm.retencion == undefined || this.modelForm.retencion == null ||
      this.modelForm.impuestoPagadoExterior == undefined || this.modelForm.impuestoPagadoExterior == null
    );
  }

  public redondearFormData() {
    // console.log('this.modelForm antes de redondear:' + JSON.stringify(this.modelForm));



    this.modelForm.valorItem = this.dutilidades.redondearValorMoneda(this.modelForm.valorItem, true);
    this.modelForm.retencion = this.dutilidades.redondearValorMoneda(this.modelForm.retencion, true);
    this.modelForm.impuestoPagadoExterior = this.dutilidades.redondearValorMoneda(this.modelForm.impuestoPagadoExterior, true);

    // console.log('this.modelForm después de redondear:' + JSON.stringify(this.modelForm));
  }

  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();

    //casillas ocultas vvvv


if(this.modelForm.concepto=='4'){
this.modelForm.retencion='0';  
}

    this.reloadSelArticulos(conservarArt);
  }

  public reloadCifras() {
    if (this.modelForm.concepto != '4') {
      this.modelForm.impuestoPagadoExterior = "0";
    }
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      // this.modelForm.nombreConcepto = this.lstConceptos[Number(this.modelForm.concepto) - 1].nombre;//envía nombre de concepto a la tabla de dividendos
      // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla == this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        // const existeValor = this.model.doc.cuerpo.cc_id_490.some(item => item.v === this.modelForm.pagador);


        // if (this.modelForm.origen == "2" || this.modelForm.origen == "1" || (existeValor && this.modelForm.origen == "0")) { //editando contribuyente o editando sugerida
        //   this.modelForm.origen = this.modelForm.origen == "0" && this.modelForm.origen == "0" ? "1" : this.modelForm.origen;
        //   this.editModeloDesdeForm();
        // } else if (this.modelForm.origen == "0") { //editando sugerida
        //   this.modelForm.origen = "1";
        //   this.modelForm.id = this.model.doc.cuerpo.cc_id_490.length;
        //   this.addToModeloDesdeForm();
        // }
        // this.modelForm.nombreConcepto = this.lstConceptos[Number(this.modelForm.concepto) - 1].nombre;//envía nombre de concepto a la tabla de dividendos
        // this.modelForm.adquisicionNombre = this.listaModoAdquisicion[Number(this.modelForm.adquisicion)-1].nombre;
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
        // this.editModeloDesdeForm();
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) { //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_490.length;
        this.modelForm.origen = "2";
        this.modelForm.informante = "Contribuyente";
        if(this.modelForm.concepto &&this.modelForm.concepto!=''){
          this.modelForm.nombreConcepto = this.lstConceptos.find(elemento=>elemento.valor.toString()==this.modelForm.concepto).nombre;
          }
        // this.modelForm.adquisicionNombre = this.listaModoAdquisicion[Number(this.modelForm.adquisicion) - 1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs494();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs494();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }


  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  /*   public validateRbQuestions(val: string) {
      this.modelForm.aplicoArt73 = val;
      this.calcularValoresForm();
    } */

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /*  public validateStepHabilitado(indexS:number):boolean{
     let habilitado = true;
     return habilitado;
   } */

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /* public validateBtnRightActive(){

  } */

  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs494();
    /* this.changeStepLocal(0); */
    this.dialogRef.close("");
  }
  public guardar() {
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_490 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs494();

    this.saveModel.emit(true);
    //if(this.indexStepper==this.stepsList.length-1){
    this.closeModal();
    //} 
  }
  public borrarTabla() {
    this.dataSourceBody = [];
  }



}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-dividendos-participaciones-modal/ingresos-dividendos-participaciones-modal.component.ts